import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';

const statusCss = {
  PAID: 'c-badge-success',
  PROCESSING: 'c-badge-info',
  PENDING: 'c-badge-warning',
  FAILED: 'c-badge-danger',
  SUBMITTED: 'c-badge-info',
  'PENDING SUBMISSION': 'c-badge-info',
};

export const StatusBadge = ({ status }) => {
  const className = statusCss[status.toUpperCase()];
  return <Badge className={`c-badge ${className}`}>{status}</Badge>;
};

StatusBadge.propTypes = {
  status: PropTypes.string,
};

StatusBadge.defaultProps = {
  status: 'Paid',
};
export default StatusBadge;
